import React, { Fragment } from 'react'
// import "react-pagebuilder/styles/sass/base/base.sass"

const LayoutEmpty = (props) => {
  return <Fragment>{props.children}</Fragment>
}

export default LayoutEmpty
